import styled from 'styled-components';

import { colors } from '/css';
import formatPrice, { formatDiscountPrice } from '/lib/utils/formatPrice';
import Paragraph from '/components/ui/Paragraph';

interface PriceComponentProps {
    className?: string;
    label: string;
    value: number;
    isDiscount?: boolean;
}

export default function PriceComponent({
    className = '',
    label,
    value,
    isDiscount,
}: PriceComponentProps) {
    if (!value) return null;

    return (
        <StyledParagraph medium className={'price-component ' + className}>
            <span>{label}</span>
            <span className={`${isDiscount ? 'discount' : ''} ${className}`}>
                {isDiscount ? formatDiscountPrice(value) : formatPrice(value)}
            </span>
        </StyledParagraph>
    );
}

const StyledParagraph = styled(Paragraph)`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .discount {
        color: ${colors.orange};
    }

    &.color-grey span {
        color: ${colors.grey6};
    }
`;
